import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
const e = React.createElement;
const baseUrl = process.env.REACT_APP_API_BASE_URL;
function Login() {
  const [formData, setFormData] = useState({ username: '', password: ''});
  const [status, setStatus] = useState('');

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const response = await fetch(`${baseUrl}/admin/admin-login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  });
  
   if (!response.ok) {
    const errorData = await response.json();
    console.log("Error");
    throw new Error(errorData.error || 'Login failed');
  }
    
    localStorage.setItem('userToken', (await response.json()).token);
    window.location.href = '/admin';
    setStatus('Login Successfull');
    setFormData({ username: '', password: '' });
  };

  return e('div', { className: 'page-content' },
    e('h1', null, 'Contact Us'),
    e('form', { onSubmit: handleSubmit, className: 'contact-form' },
      e('input', { type: 'text', name: 'username', placeholder: 'Username', value: formData.username, onChange: handleChange, required: true }),
      e('input', { type: 'password', name: 'password', placeholder: 'Password', value: formData.password, onChange: handleChange, required: true }),
      e('button', { type: 'submit' }, 'Send Message')
    ),
    status ? e('p', { className: 'success-msg' }, status) : null
  );
}

export default Login;